export const locale = {
    lang: 'es',
    data: {
        'LOGOUT': {
            'TITLE': 'Desconectarse',
            'MESSAGE': '¿Estás seguro que quiere desconectarse?',
            'YES': 'Sí',
            'NO': 'No'
        }, 'ERROR': {
            'NO_ORGANIZATION': 'Se debe conectar una organización antes de acceder a esta opción del menú de navegación'
        }
    }
};
